import { NoteRemoveIcon } from './NoteRemoveIcon';

/**
 * author: Colton Wiscombe
 * id 948C92D0-A16F-48FD-8A25-37898D6B9768
 * name note-remove
 * version: 5.7.55
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/note-remove.svg
 * tags
 */
export const PaperRemoveIcon = NoteRemoveIcon;
export default PaperRemoveIcon